interface PostContentProps {
  content: string;
}

export function PostContent({ content }: PostContentProps) {
  return <div className="line-clamp-3 min-h-15.5 text-sm leading-5 text-zinc-900">{content}</div>;
}
